module.exports = __webpack_public_path__ + "static/media/pump.19accbb1.png";